import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import { TableCell, IconButton, Button, Dialog, DialogActions, DialogContent, DialogTitle, Select, MenuItem, Typography, Grid } from '@material-ui/core';
import { LinkOff } from '@material-ui/icons';
import {  TasksDispatchContext,useTask } from '../stateManagement/context';
import { IInvestigation, IInvestigationAssessment } from '../types/types';
import { post } from '../fetchers/fetchers';
import { getInvestigationAssessment, getInvestigations } from '../stateManagement/data';
import { useParams } from "react-router";
import { API_URL } from "../env";
import AddInvestigationDialog from './add_investigation_dialog';

interface InvestigationsCellProps {
    writeAccess: boolean;
    elementUUID : number;
    linkType: number
}

interface IRouteParams {
    id: string
}

const InvestigationsCell: React.FC<InvestigationsCellProps> = ({
    writeAccess,
    elementUUID,
    linkType
}) => {
    const [openInvestigationAdd, setOpenInvestigationAdd] = React.useState<boolean>(false);
    const [selectedInvestigation, setSelectedInvestigation] = React.useState<number | null>(null);
    const [investigations, setInvestigations] = React.useState<IInvestigation[]>([]);
    const [currentInvestigations, setCurrentInvestigations] = React.useState<IInvestigation[]>([]);
    const [openCreateDialog, setOpenCreateDialog] = React.useState<boolean>(false);
    

    let tasks = useTask()

    React.useEffect(() => {
        if (tasks.loaded){
            setInvestigations(tasks.investigations)

             // filter investigationassessment

            const invs_ids = tasks.investigationAssessments.filter(ia =>
                 ia.assessment_uuid === elementUUID && ia.link_type === linkType).map(ia => ia.investigation_uuid)
                
            const invs = tasks.investigations.filter(i => invs_ids.includes(i.uuid))
            setCurrentInvestigations(invs)
        
    }


    },[tasks])

    const params = useParams<IRouteParams>()

    let dispatch = React.useContext(TasksDispatchContext)


    const handleAddInvestigation = () => {
        setOpenInvestigationAdd(true);
    };

    const updateInvestigation = (i: IInvestigation) => {
        delete i.document
        delete i.id
        delete i.group
        postInvestigation(i).then(() => {

        })
    }
    const postInvestigation = async (f: IInvestigation) => {
        await post<IInvestigation>(API_URL + "investigations/" + + params.id + "/", f);
        await getInvestigations(params.id, dispatch)
    }

    const handleClose = () => {
        setOpenCreateDialog(false)
    }


    const handleCloseInvestigationDlg = () => {
        setOpenInvestigationAdd(false)
    }

    const handleLinkInvestigation = async (f: IInvestigationAssessment) => {
        handleCloseInvestigationDlg()
        await post<IInvestigationAssessment>(API_URL + "investigations/" + params.id + "/investigation_assessment", f);
        await getInvestigationAssessment(params.id, dispatch)

    }

    const handleOpen = () => {
        setOpenCreateDialog(true)
    }
    

    const RenderInvestigationsDlg = () => {
        const [selectedInvestigationUUID, setSelectedInvestigationUUID] = React.useState<number>(-1)
        return (
            <Dialog open={openInvestigationAdd} onClose={() => setOpenInvestigationAdd(false)} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Link Investigation</DialogTitle>
                <DialogContent>
                    <Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                        <Select
                            style={{ fontSize: "11pt" }}
                            onChange={(event) => {
                                let value = parseInt(event.target.value as string)
                                setSelectedInvestigationUUID(value)
                            }}>
                            {
                                
                                investigations.map((i) => {
                                    return (
                                        <MenuItem value={i.uuid}>{i.name}</MenuItem>
                                    )
                                })

                            }

                        </Select>
                        </Grid>
                        <Grid item xs={6}>
                              <IconButton color="primary" component="span"
                              style={{
                                  margin: "auto",
                                  backgroundColor: "rgb(239,88,43)",
                                  color: "rgb(255,255,255)"
                              }} onClick={() => handleOpen()}>
                              <AddIcon fontSize="small" />
                          </IconButton>
                          </Grid>
                        </Grid>
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleCloseInvestigationDlg}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={() => handleLinkInvestigation(
                        {
                            investigation_uuid: selectedInvestigationUUID,
                            assessment_uuid: elementUUID,
                            link_type: linkType,
                            is_active: true
                        }
                    )}>

                        Confirm
                    </Button>
                </DialogActions>

            </Dialog>)

    }


    return (
        <>
            <RenderInvestigationsDlg />
            {openCreateDialog && <AddInvestigationDialog investigation={{
                uuid: -1, is_active: true
            }} updateInvestigation={updateInvestigation} closeDialogCallback={handleClose} />}


            <>
                {currentInvestigations.map((investigation) => (
                    <div key={investigation.uuid}>
                        {investigation.name}
                        {writeAccess && (
                            <IconButton
                                color="primary"
                                
                                aria-label="unlink investigation"
                                onClick={ ()=>handleLinkInvestigation(
                                    {
                                        investigation_uuid: investigation.uuid,
                                        assessment_uuid: elementUUID,
                                        link_type: linkType,
                                        is_active: false
                                    })}
                            >
                                <LinkOff />
                            </IconButton>
                        )}
                    </div>
                ))}
                {writeAccess && (
                    <Button
                        color="secondary"
                        onClick={handleAddInvestigation}
                        style={{ color: 'rgb(239,88,43)' }}
                    >
                        link
                    </Button>
                )}
            </>
        </>
    );
};
            

export default InvestigationsCell;
